import { render, staticRenderFns } from "./SettingsNavigationItem.vue?vue&type=template&id=ebd7f42a"
import script from "./SettingsNavigationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsNavigationItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsNavigationItem.vue?vue&type=style&index=0&id=ebd7f42a&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports